import moment from "moment";
import { Priority, TicketStatus } from "../enums";
import { TagResult } from "../tag";

export class TicketTaskResult {
    public id: number = 0;
    public customerId: number = 0;
    public customerName: string = '';
    public projectId: number = 0;
    public projectName: string = '';
    public creationDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public priority: Priority = 0;
    public ticketStatus: TicketStatus = 0;
    public title: string = '';
    public assignedEmployeeId: number | null = 0;
    public assignedEmployeeFullName: string = '';
    public assignedEmployeePersonalPictureFileName: string = '';
    public tags: Array<TagResult> = [];
}
